import React from "react";
import "./ContactUs.css";

const ContactUs: React.FC = () => {
  return (
    <main className="contact-content">
      <h1>Contact Us</h1>
      <p>
        We'd love to hear from you! Whether you have questions, feedback, or suggestions, feel free
        to reach out to us. Your input is invaluable in helping us improve our app.
      </p>
      <p>
        Email us at: <a href="mailto:sl842378991@gmail.com">sl842378991@gmail.com</a>
      </p>
      <p>Thank you for using DriveTest Prep!</p>
    </main>
  );
};

export default ContactUs;
